import constants from '../config/constants'
import { FirebaseError, AppError } from '../config/enums'

/**
 * Returns a friendly error message for a given error or code
 * @param error - can be an Error object or error.code (string)
 */
export const friendlyMessageFor = (error: any): string => {
  if (
    typeof error === 'object' &&
    error.code &&
    error.message &&
    error.details
  ) {
    // Assume this is a functions.https.HttpsError
    return error.message // return user friendly error message
  }

  let message = constants.alertError.generic
  let errorCode = 'unknown'

  if (typeof error === 'string') {
    // Treat error param as the error code itself
    errorCode = error as string
  } else if (typeof error === 'object' && error.code) {
    // Get error code from error object
    errorCode = error.code as string
  } else {
    // Unknown error type, return generic error message
    return message
  }

  switch (errorCode) {
    /**
     * FirebaseAuth error codes
     *
     * Refer to this link for possible error codes
     * https://firebase.google.com/docs/reference/js/firebase.auth.Auth?authuser=0#createuserwithemailandpassword
     * */
    case FirebaseError.authEmailAlreadyInUse:
      message = constants.alertError.auth.emailAlreadyUsed
      break
    case FirebaseError.authInvalidEmail:
      message = constants.alertError.auth.invalidEmail
      break
    case FirebaseError.authOperationNotAllowed:
      message = constants.alertError.auth.signInMethodNotAvailable
      break
    case FirebaseError.authWeakPassword:
      message = constants.alertError.auth.weakPassword
      break
    case FirebaseError.authUserDisabled:
      message = constants.alertError.auth.userDisabled
      break
    case FirebaseError.authUserNotFound:
    case FirebaseError.authWrongPassword:
      message = constants.alertError.auth.incorrectEmailOrPassword
      break
    case FirebaseError.authInvalidVerifyCode:
      message = constants.alertError.auth.authInvalidVerifyCode
      break
    case FirebaseError.authInvalidPhonenumber:
      message = constants.alertError.auth.authInvalidPhonenumber
      break

    /**
     * Custom app error codes
     */
    case AppError.formInvalid:
      message = constants.alertError.formInvalid
      break
    case AppError.unregisteredAccount:
      message = constants.alertError.auth.unregisteredAccount
      break
    case AppError.currentPasswordIncorrect:
      message = constants.alertError.editProfile.currentPasswordIncorrect
      break
    case AppError.currentPasswordBlank:
      message = constants.alertError.noCurrentPassword
      break
  }

  return message
}
